import { quickNav, siteInfo } from '@/mocks/siteInfo';

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-primary-950 px-4 py-12 md:px-6 md:py-16">
      <div className="mx-auto max-w-6xl">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-accent-500 text-sm font-bold text-accent-950">
                会
              </span>
              <span className="font-heading text-lg font-bold text-background-50">{siteInfo.name}</span>
            </div>
            <p className="mt-4 max-w-sm text-xs leading-relaxed text-background-200">
              {siteInfo.tagline}。本站专注于剧情整理与观感解析，把故事梗概、分部（分集）剧情、人物关系与结局解析集中在一页。
            </p>
            <p className="mt-3 text-xs text-background-300">{siteInfo.originalName} · {siteInfo.englishName}</p>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-background-50">页面分区</h3>
            <ul className="mt-4 grid grid-cols-2 gap-2">
              {quickNav.map((item) => (
                <li key={item.id}>
                  <a
                    href={`#${item.id}`}
                    className="text-xs text-background-200 transition-colors hover:text-accent-300"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-background-50">内容声明</h3>
            <p className="mt-4 text-xs leading-relaxed text-background-200">
              本页为剧情资料与个人观感整理，内容基于公开信息与观影梳理，仅供追剧参考，具体情节请以正片为准。本站不提供任何片源、下载或在线播放，请通过正规渠道观看。
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-50/15 pt-6 text-xs text-background-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} {siteInfo.name}剧情资料页 · 仅供学习与交流</p>
          <p className="whitespace-nowrap">一次看懂，追剧不迷路</p>
        </div>
      </div>
    </footer>
  );
}